import { Link } from 'react-router-dom';
import { DonationHeader } from './DonationHeader';
import { useLocale } from '@/context/LocaleContext';
import '@/styles/donation-layout.css';

export function DonationCancelPage() {
  const { t } = useLocale();

  return (
    <div className="container-ingame donation-page">
      <div className="donation-container">
        <DonationHeader />
        <div className="donation-content donation-state-message">
          <h2 style={{ marginBottom: 16 }}>{t('don_cancel_title')}</h2>
          <p>{t('don_cancel_msg')}</p>
          <Link
            to="/donation"
            className="donation-btn donation-btn-primary"
            style={{ marginTop: 24, display: 'inline-block' }}
          >
            {t('don_back_to')}
          </Link>
        </div>
      </div>
    </div>
  );
}
